/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

/**
 * Date window the COMPLETE grid is read with (OS-587). `field` is the grid date column
 * the window applies to (etd / eta / feta). Both ends are "YYYY-MM-DD" and inclusive;
 * null means the server default (the past year up to today). Completed shipments pile
 * up without limit, so the grid never reads them all at once.
 */
const initialState = { field: 'etd', start: null, end: null };

const completeDateWindowSlice = createSlice({
    name: 'completeDateWindow',
    initialState,
    reducers: {
        setCompleteDateWindow: (state, action) => {
            const { field, start, end } = action.payload ?? {};
            state.field = field || initialState.field;
            state.start = start ?? null;
            state.end = end ?? null;
        },
        resetCompleteDateWindow: () => initialState,
    },
});

export const { setCompleteDateWindow, resetCompleteDateWindow } = completeDateWindowSlice.actions;
export default completeDateWindowSlice.reducer;
